export default "__VITE_PUBLIC_ASSET__47430624__"